import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	contractType: null,
	error: "",
	loading: false,
};

// ADD_contractType
export const addContractType = createAsyncThunk(
	"contractType/addContractType",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `contractType`,
				data: {
					...values,
				},
			});
			toast.success("Contract Type added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Contract Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_contractType
export const deleteContractType = createAsyncThunk(
	"contractType/deleteContractType ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `contractType/${id}`,
			});

			toast.success("Contract Type deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Contract Type try again");
			console.log(error.message);
		}
	}
);

// contractTypeS
export const getAllContractType = createAsyncThunk(
	"contractType/getAllContractType",
	async () => {
		try {
			const { data } = await axios.get(`contractType`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateContractType = createAsyncThunk(
	"contractType/updateContractType",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `contractType/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Contract Type updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Contract Type try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const contractTypeSlice = createSlice({
	name: "contractType",
	initialState,
	reducers: {
		clearContractType: (state) => {
			state.contractType = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllContractType ======

		builder.addCase(getAllContractType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllContractType.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllContractType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addContractType  ======

		builder.addCase(addContractType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addContractType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addContractType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for contractType ======

		builder.addCase(updateContractType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateContractType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateContractType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteContractType  ======

		builder.addCase(deleteContractType.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteContractType.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteContractType.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default contractTypeSlice.reducer;
export const { clearContractType } = contractTypeSlice.actions;
